import { resolvePlanPrescription } from "./patientPrescription";

export function activePrescriptionRows(plans = []) {
  return plans.flatMap((plan) => (plan.exercises || [])
    .filter((row) => row.is_active !== false)
    .map((row) => ({ ...row, source_plan_title: plan.title, source_plan_type: plan.plan_type })));
}

export function patientExercise(row) {
  const details = resolvePlanPrescription(row);
  const exercise = row.exercise || row;
  const youtubeId = details.youtube_video_id;
  return {
    ...details,
    patient_notes: row.patient_notes || "",
    title: details.title === "Exercise" ? exercise["Exercise / Activity"] || "Exercise" : details.title,
    instructions: details.instructions || exercise["Instructions Placeholder"] || "",
    key_cues: details.key_cues || exercise.technique_cues || "",
    safety_notes: details.safety_notes || exercise.safety_notes || exercise["Pain Guidelines"] || "",
    video_url: details.video_url || (/^[A-Za-z0-9_-]{11}$/.test(youtubeId || "")
      ? `https://www.youtube.com/watch?v=${youtubeId}` : ""),
  };
}

export function dosageLabel(details) {
  const parts = [];
  if (details.sets && details.reps) parts.push(`${details.sets} sets × ${details.reps} reps`);
  else if (details.sets) parts.push(`${details.sets} sets`);
  else if (details.reps) parts.push(`${details.reps} reps`);
  if (details.hold_time) parts.push(`${details.hold_time} hold`);
  if (details.frequency) parts.push(details.frequency);
  return parts.join(" · ") || "Dosage as prescribed";
}
